import BaseModel from '../core/BaseModel';

export default class HistoryFormalModel extends BaseModel {
    constructor() {
        super(
            { 
                name: "history_formal_td",
                tableName: 'history_formal_td', 
                label: "Lịch sử hình thức tống đạt",
            }, 
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: { 
                    name: 'id', 
                    type: "Int", 
                    label: 'ID', 
                    primaryKey: true, 
                    display: false
                },
                date_change: {
                    name: "date_change",
                    type: "Date",
                    label: "Ngày thay đổi",
                    filter: { type: "DateRange", label: "Chọn ngày thay đổi" }
                },
                type: {
                    name: "type",
                    type: "String",
                    label: "Loại hình thức tống đạt"
                },
                user_id: {
                    name: "user_id",
                    type: "Text",
                    label: "ID người dùng"
                },
                document_id: {
                    name: "document_id",
                    type: "Int",
                    label: "ID tài liệu"
                },
                document_status: {
                    name: "document_status",
                    type: "String",
                    label: "Trạng thái tài liệu"
                },
                document_status_code: {
                    name: "document_status_code",
                    type: "Int",
                    label: "code document"
                },
                created_at: {
                    name: "created_at",
                    type: "Datetime",
                    label: "Ngày tạo",
                    filter: { type: "DateRange", label: "Chọn ngày tạo" }
                },
                updated_at: {
                    name: "updated_at",
                    type: "Datetime",
                    label: "Ngày cập nhật",
                    filter: { type: "DateRange", label: "Chọn ngày cập nhật" }
                },
                created_by: {
                    name: "created_by",
                    type: "String",
                    label: "Người tạo",
                    display: false
                },
                updated_by: {
                    name: "updated_by",
                    type: "String",
                    label: "Người cập nhật",
                    display: false
                },
                deleted: {
                    name: "deleted",
                    type: "Boolean",
                    label: "Đã xóa",
                    display: false
                }
            }
        );
    }
}